export function formatDateToYYYYMMDD(dateInput) {
    let date;
  
    // Check if input is provided
    if (!dateInput) {
      console.log('No date input provided. Returning null.');
      return null;
    }
  
    // Handle different input types
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'string') {
      // Replace common separators and trim whitespace
      const cleanedInput = dateInput.replace(/[-\/\.]/g, '-').trim();
      date = new Date(cleanedInput);
    } else if (typeof dateInput === 'number') {
      // Assume it's a timestamp (in milliseconds)
      date = new Date(dateInput);
    } else {
      console.log('Unsupported input type. Use a Date object, string, or timestamp. Returning null.');
      return null;
    }
  
    // Check if the resulting date is valid
    if (isNaN(date.getTime())) {
      console.log('Invalid date value. Please provide a valid date. Returning null.');
      return null;
    }
  
    // Check if year is within a reasonable range (e.g., 1900 to 9999)
    const year = date.getFullYear();
    if (year < 1900 || year > 9999) {
      console.log('Year out of valid range (1900-9999). Returning null.');
      return null;
    }
  
    // Extract and format year, month, and day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
  
    // Validate month and day
    if (month < 1 || month > 12) {
      console.log('Invalid month value. Returning null.');
      return null;
    }
    if (day < 1 || day > 31) {
      console.log('Invalid day value. Returning null.');
      return null;
    }
  
    return `${year}-${month}-${day}`;
  }